// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM12.0002 4.5C9.2711 4.5 7.0502 6.7209 7.0502 9.45C7.0502 10.1991 7.2141 10.9174 7.5375 11.5862C8.1007 12.7544 8.7211 14.0788 9.2205 15.5H14.7799C15.2804 14.0788 15.8997 12.7544 16.464 11.5862C16.7874 10.9174 16.9502 10.1991 16.9502 9.45C16.9502 6.7209 14.7304 4.5 12.0002 4.5ZM9.5 17V19H14.5V17H9.5Z"}}]};

const LightbulbCircleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lightbulb-circle-filled',
    ref,
    icon: element,
  },
));

LightbulbCircleFilledIcon.displayName = 'LightbulbCircleFilledIcon';

export default LightbulbCircleFilledIcon;
